import { render, staticRenderFns } from "./packconfirm.vue?vue&type=template&id=1a310e99"
import script from "./packconfirm.vue?vue&type=script&lang=ts"
export * from "./packconfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports